import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {TaxReportComponent} from "./tax-report.component";
import {TaxReportRoutingModule} from "./tax-report-routing.module";
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule} from "primeng/primeng";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule,
    TranslateModule,
    // TaxReportRoutingModule
  ],
  declarations: [TaxReportComponent]
})
export class TaxReportModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.module.ts